var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-with-unit',{attrs:{"alternative-units":['px'],"size":"small"},on:{"updated":_vm.set},model:{value:(_vm.fontSize),callback:function ($$v) {_vm.fontSize=$$v},expression:"fontSize"}})}
var staticRenderFns = []

export { render, staticRenderFns }